import { render, staticRenderFns } from "./contrato.vue?vue&type=template&id=36fd1fdd&"
import script from "./contrato.vue?vue&type=script&lang=js&"
export * from "./contrato.vue?vue&type=script&lang=js&"
import style0 from "./contrato.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports